var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16645C9.88099 4.16645 7.73801 6.30944 7.73801 8.92844C7.73801 11.5474 9.88099 13.6904 12.5 13.6904C15.119 13.6904 17.262 11.5474 17.262 8.92844C17.262 6.30944 15.119 4.16645 12.5 4.16645ZM12.5 12.5C10.5357 12.5 8.92857 10.8929 8.92857 8.92857C8.92857 6.96422 10.5357 5.35714 12.5 5.35714C14.4643 5.35714 16.0714 6.96422 16.0714 8.92857C16.0714 10.8929 14.4643 12.5 12.5 12.5ZM12.5 0C5.59503 0 0 5.59528 0 12.5C0 19.4047 5.59528 25 12.5 25C19.4047 25 25 19.4047 25 12.5C25 5.59528 19.4047 0 12.5 0ZM5.35714 21.25C5.41668 20.4167 5.77393 16.6666 9.52372 16.6666H15.4763C19.2263 16.6666 19.5833 20.4167 19.6429 21.25C17.6785 22.8571 15.2381 23.8095 12.5 23.8095C9.82143 23.8095 7.32149 22.8571 5.35714 21.25ZM20.7143 20.2381C20.357 18.1547 18.9881 15.4761 15.4762 15.4761H9.52366C6.0118 15.4761 4.6426 18.1547 4.28559 20.2381C2.3808 18.2145 1.1905 15.4763 1.1905 12.5002C1.1905 6.25019 6.24994 1.19088 12.4998 1.19088C18.7497 1.19088 23.8091 6.25032 23.8091 12.5002C23.8091 15.4765 22.6188 18.2146 20.714 20.2381H20.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.af4c9ff161935d20aa0cc6e1cbc60b3d.svg";
export { ForwardRef as ReactComponent };